"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdapterSignatureSSS = void 0;
const features_1 = require("../../features");
const constants_1 = require("../constants");
// Types
const types_1 = require("../../features/authoriser/types");
const types_2 = require("../../features/types");
// Events
const events_1 = require("../../features/events");
class AdapterSignatureSSS {
    constructor(authoriser, eventBus) {
        this.subscribers = [];
        this.signatureId = null;
        this.challenge = types_1.ChallengeType.NONE;
        this.currentSubscriptions = [];
        this.initialize = (_a) => __awaiter(this, [_a], void 0, function* ({ resolve, response }) {
            const challengeResponseData = response.data.data;
            this.resolve = resolve;
            this.originalRequest = response.calls.originCall;
            this.originalResponse = response;
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: undefined },
                state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                type: 'loading',
                success: false,
            }, this.eventBus);
            this.signatureService.reset();
            this.signatureId = challengeResponseData.progressId;
            this.signatureService.initializeAuthoriser(challengeResponseData, this.originalRequest, response.reference.url);
            this.signatureService.onStateChange((state) => this.onStateChangeCallback(state));
            (0, events_1.subscribeResentChallengeEvent)(this.onRetryChallengeStatusChange, this.eventBus);
        });
        this.onStateChangeCallback = (state) => {
            var _a, _b, _c, _d;
            this.currentSubscriptions.forEach(unsubscriber => unsubscriber());
            this.challenge = (_c = (_b = (_a = this.signatureService.challenge) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : types_1.ChallengeType.NONE;
            if (state.isChallengeVerificationFailed) {
                this.handleValidationError();
                return;
            }
            if (state.isFailed) {
                this.handleError(state);
                return;
            }
            if (state.isChallengeLoading || state.isChallengeVerifying) {
                (0, events_1.publishShowSignatureEvent)({
                    challenge: { data: (_d = this.signatureService.challenge) === null || _d === void 0 ? void 0 : _d.data },
                    state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                    type: 'loading',
                    success: false,
                }, this.eventBus);
                return;
            }
            if (state.isFinishing) {
                return;
            }
            if (state.isReadyToFinish) {
                this.tryToFinish();
                return;
            }
            if (state.isStarted) {
                this.start();
            }
        };
        this.start = () => {
            var _a;
            this.stateMachine.init({ state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED, type: this.challenge });
            this.currentSubscriptions.push((0, events_1.subscribeValidateSignatureEvent)((credentials) => {
                if (!credentials) {
                    return this.retryChallenge();
                }
                this.validateCredentials(credentials);
            }, this.eventBus));
            this.currentSubscriptions.push((0, events_1.subscribeCancelSignatureEvent)(this.cancel, this.eventBus), (0, events_1.subscribeResetSignatureEvent)(this.reset, this.eventBus));
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: (_a = this.signatureService.challenge) === null || _a === void 0 ? void 0 : _a.data },
                state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                success: true,
            }, this.eventBus);
        };
        this.onRetryChallengeStatusChange = ({ success }) => {
            var _a;
            (0, events_1.publishShowSignatureEvent)({
                challenge: {
                    data: (_a = this.signatureService.challenge) === null || _a === void 0 ? void 0 : _a.data,
                    retryStatus: success ? types_2.RetryStatuses.SUCCESS : types_2.RetryStatuses.ERROR,
                },
                state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                success: true,
            }, this.eventBus);
        };
        this.retryChallenge = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                (0, events_1.publishShowSignatureEvent)({
                    challenge: {
                        data: (_a = this.signatureService.challenge) === null || _a === void 0 ? void 0 : _a.data,
                        retryStatus: types_2.RetryStatuses.LOADING,
                    },
                    state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                    success: true,
                }, this.eventBus);
                return yield this.signatureService.retryChallenge();
            }
            catch (error) {
                return this.setError(types_2.SignatureStateEnum.TECHNICAL_ERROR, types_2.SignatureError.GENERIC);
            }
        });
        this.validateCredentials = (credentials) => __awaiter(this, void 0, void 0, function* () {
            if (!credentials) {
                throw Error('Credentials cannot be null');
            }
            try {
                yield this.signatureService.verifyChallenge(credentials);
            }
            catch (err) {
                const error = err;
                if (error.httpStatus === constants_1.STATUS_ERROR) {
                    this.setError(types_2.SignatureStateEnum.TECHNICAL_ERROR, types_2.SignatureError.GENERIC);
                }
                else {
                    this.setError(types_2.SignatureStateEnum.SIGNATURE_FAILED, types_2.SignatureError.GENERIC);
                }
            }
        });
        this.handleValidationError = () => {
            var _a;
            this.stateMachine.init({ state: types_2.SignatureStateEnum.TECHNICAL_ERROR });
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: (_a = this.signatureService.challenge) === null || _a === void 0 ? void 0 : _a.data },
                state: types_2.SignatureStateEnum.TECHNICAL_ERROR,
                type: types_2.SignatureError.FAILED_VERIFICATION,
                success: false,
            }, this.eventBus);
        };
        this.getCurrentState = () => this.stateMachine.getCurrentState();
        this.setError = (state, type = types_2.SignatureError.GENERIC) => {
            this.signatureService.fail(state === types_2.SignatureStateEnum.SIGNATURE_FAILED, type);
            this.stateMachine.onTransition({ state });
            (0, events_1.publishErrorSignatureEvent)({ state, type }, this.eventBus);
        };
        this.handleError = (state) => {
            this.stateMachine.init({ state: types_2.SignatureStateEnum.SIGNATURE_FAILED });
            let type;
            if (state.error === types_2.SignatureError.EXPIRED_SIGNATURE_KEY) {
                type = types_2.SignatureError.EXPIRED_SIGNATURE_KEY;
            }
            else if (state.isBlocked || state.isChallengeBlocked) {
                type = types_2.SignatureError.CONSECUTIVE_ERRORS;
            }
            else {
                type = types_2.SignatureError.GENERIC;
            }
            (0, events_1.publishErrorSignatureEvent)({
                state: types_2.SignatureStateEnum.SIGNATURE_FAILED,
                type,
            }, this.eventBus);
        };
        this.cancel = () => {
            var _a;
            if (this.stateMachine.getCurrentState().state === types_2.SignatureStateEnum.SIGNATURE_COMPLETED ||
                this.stateMachine.getCurrentState().state === types_2.SignatureStateEnum.IDLE) {
                return;
            }
            this.signatureService.reset();
            this.stateMachine.onTransition({ state: types_2.SignatureStateEnum.SIGNATURE_CANCELLED });
            (0, events_1.publishShowSignatureEvent)({
                state: types_2.SignatureStateEnum.SIGNATURE_CANCELLED,
                success: true,
                challenge: { data: types_1.ChallengeType.NONE },
            }, this.eventBus);
            (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, this.originalResponse);
            this.clearRequestInfo();
        };
        this.tryToFinish = () => {
            var _a;
            this.isSignatureConfirmationProcessing(true);
            (_a = this.originalRequest) === null || _a === void 0 ? void 0 : _a.call(this);
        };
        this.finishSuccessfully = (response) => {
            var _a;
            (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, response);
            this.stateMachine.onTransition({ state: types_2.SignatureStateEnum.SIGNATURE_COMPLETED });
            (0, events_1.publishFinishSignatureEvent)({ state: types_2.SignatureStateEnum.SIGNATURE_COMPLETED }, this.eventBus);
            this.clearRequestInfo();
        };
        this.clearRequestInfo = () => {
            this.signatureId = null;
            this.originalRequest = undefined;
            this.resolve = undefined;
        };
        this.reset = () => {
            this.signatureService.reset();
            this.stateMachine.setState({ state: types_2.SignatureStateEnum.IDLE });
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: undefined },
                state: types_2.SignatureStateEnum.IDLE,
                success: false,
            }, this.eventBus);
            this.clearRequestInfo();
        };
        this.getSignatureId = () => { var _a; return (_a = this.signatureId) !== null && _a !== void 0 ? _a : ''; };
        this.isSignatureProcessStarted = () => this.stateMachine.getCurrentState().state === types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED && this.signatureService.state.isStarted;
        if (!eventBus) {
            throw new Error('EventBus is required');
        }
        this.signatureService = authoriser;
        this.stateMachine = new features_1.StateMachine({ stateList: types_2.signatureStates, inititialState: { state: types_2.SignatureStateEnum.IDLE } });
        this.eventBus = eventBus;
    }
    onStateChange(callback) {
        this.subscribers.push(callback);
        this.stateMachine.setSubscribers(this.subscribers);
    }
    isSignatureLastProcess(requestId) {
        return !!this.signatureService.progressId && requestId === this.signatureService.requestId;
    }
    isSignatureConfirmationProcessing(isConfirming) {
        this.signatureService.updateState({ isFinishing: isConfirming });
    }
}
exports.AdapterSignatureSSS = AdapterSignatureSSS;
//# sourceMappingURL=AdapterSignatureSSS.js.map